/*
 * vrtPSTrainee.ts
 */
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

function mfRequireAssignmentIdRoute(to: RouteLocationNormalized) {
  const lsAssignmentId = typeof to.params.assignmentId === 'string' ? to.params.assignmentId : '';
  return lsAssignmentId.trim() !== '' ? true : { name: 'vrtPSTraineeVLogbook' };
}
//
const vrtPSTrainee: RouteRecordRaw = {
  path: '/powersteer/trainee',
  name: 'vrtPSTrainee',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // OPERATION
    {
      path: 'operation/parade/state',
      name: 'vrtPSTraineeOperationParadeState',
      component: () => import('./vpgPSTraineeOperationParadeState.vue'),
    },
    {
      path: 'operation/lesson/taken',
      name: 'vrtPSTraineeOperationLessonTaken',
      component: () => import('./vpgPSTraineeOperationLessonTaken.vue'),
    },
    {
      path: 'operation/vlogbook/main',
      name: 'vrtPSTraineeVLogbook',
      component: () => import('./vpgPSTraineeVLogbook.vue'),
    },
    {
      path: 'operation/vlogbook/operate/:assignmentId',
      name: 'vrtPSTraineeVLogbookOperate',
      component: () => import('./vpgPSTraineeVLogbookOperate.vue'),
      beforeEnter: mfRequireAssignmentIdRoute,
    },
    {
      path: 'operation/vlogbook/operate/:assignmentId/addedit/:recordId?',
      name: 'vrtPSTraineeVLogbookOperateAddEdit',
      component: () => import('./vpgPSTraineeVLogbookOperateAddEdit.vue'),
      beforeEnter: mfRequireAssignmentIdRoute,
    },
  ],
};

export default vrtPSTrainee;
